import { oneOfType, number, string } from 'prop-types'
import { kuiperClassNames } from '../utils'

import './styles.scss'

function renderPillType(label) {
  if (label) {
    return (
      <div className={kuiperClassNames('version-number')}>
        <span>{label}</span>
      </div>
    )
  }
  return (
    <div className={kuiperClassNames('unsaved')}>
      <span>unsaved</span>
    </div>
  )
}

const Pill = ({ color, label, className }) => (
  <div className={kuiperClassNames('pill', color, className)}>
    {renderPillType(label)}
  </div>
)

Pill.propTypes = {
  className: string,
  color: string,
  label: oneOfType([number, string]),
}

export default Pill
